import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {MaterialOrderDetails} from '../types/MaterialOrderDetails';

export const useGetNewMaterialOrder = (retailOrderID: number | undefined) => {
    const { data, isLoading } = useQuery({
        queryKey: ['material-order-new', retailOrderID],
        queryFn: async () => await apiClient.get('material-order/new',
            {
                params: {
                    retailOrderID: retailOrderID
                }
            }) as MaterialOrderDetails
    });

    return {
        data,
        isLoading
    };
};
